import { keyframes } from "styled-components";

export const cardApearAnim = keyframes`
    0% {
      transform: scale(1);
    }
    6% {
      transform: scale(0.5);
    }
    40% {
      transform: scale(0.96);
      animation-timing-function: cubic-bezier(0.18, 0.05, 0.51, 0.95);
    }
    100% {
      transform: scale(1);
      animation-timing-function: cubic-bezier(0.32, 1.63, 0.65, 1);
    }
`;

export const cardChangeAnim = keyframes`
    0% {
      transform: translateX(50%) rotateZ(0deg);
    }
    100% {
      transform: translateX(372%) rotateZ(-90deg);
      animation-timing-function: cubic-bezier(0, 0, 0.5, 1);
    }
`;
